import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'my-header',
  template: require('./header.component.html'),
  styles: [require('./header.component.scss')]
})
export class HeaderComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/header.component.ts